define(function (require) {
    "use strict";

    var template = require("personalization-web-agent-templates/widget-templates/widget-edit/widgetParametersItemView.tmpl");

    var Config = require("personalization-web-agent-config/config.json");

    var InputField = require("ui/input-field/InputField");

    var WidgetParametersModel = require("personalization-web-agent-models/WidgetParametersModel");

    var WidgetParametersItemView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetParametersItemView = Marionette.ItemView.extend({
            className:"widget-params-row",
            template: template,
            ui:{
                "paramInputField": ".edit-params-view-input",
                "selectedParamField": ".edit-params-view-select"
            },
            uiComponents: {
                paramInputField: {
                    type: InputField,
                    options:{
                        permutation:InputField.Permutation.P,
                        theme: InputField.THEME.NIGHT,
                        el:"view.ui.paramInputField",
                        maxLength: Config.iFrameWidget.widgetParamNameMaxLength,
                        value: "view.model.getModelName"
                    }
                },
                valueInputField: {
                    type: InputField,
                    options:{
                        permutation:InputField.Permutation.P,
                        theme: InputField.THEME.NIGHT,
                        el:"view.ui.selectedParamField",
                        value: "view._getDisplayedValue",
                        disabled: true
                    }
                }
            },
            events: {
                "click .edit-params-view-button": "_onDeleteButtonClick",
                "blur .edit-params-view-input": "_onInputFieldBlur"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing WidgetParametersItemView", "WidgetParametersItemView:initialize");
                this.vent = options.vent;
                this.paramsMap = options.paramsMap;
                this.addCustomFields = options.addCustomFields;
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetParametersItemView", "WidgetParametersItemView:onRender");
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetParametersItemView", "WidgetParametersItemView:onClose");
            },

            /************************** public functions *****************************************************/
            onValidatedInvalid: function (model, errors) {
                if (_.has(errors, WidgetParametersModel.KEYS.NAME)) {
                    this.uiComponents.paramInputField.setError(true, errors[WidgetParametersModel.KEYS.NAME]);
                }
            },

            /************************** private functions *****************************************************/
            _getDisplayedValue: function(){
                var displayedValue = this.paramsMap[this.model.getModelValue()];
                if (!displayedValue && this.addCustomFields) {
                    displayedValue = this.model.getModelValue();
                }
                return displayedValue;
            },
            _onInputFieldBlur: function (){
                this._clearErrors();

                var value = this.uiComponents.paramInputField.getValue();

                this.model.set({name: value}, {validate: true});
            },

            _clearErrors: function(){
                this.model.clearErrors();
                this.uiComponents.paramInputField.setError(false);
            },

            _onDeleteButtonClick: function(){
                this.model.destroy();
            }
        });
    });
    return WidgetParametersItemView;
});

